import React from 'react';

export function Section({ mapping, type, variant, ...rest }) {
  const Component = mapping[type];
  if (Component === undefined) {
    return <p>{JSON.stringify({ type, variant, ...rest }, null, 2)}</p>;
  }
  return <Component {...rest} variant={variant} />;
}
